<template>
  <bulk-add
    title="Добавить возвраты"
    delete-all-message="Вы действительно хотите удалить все возвраты?"
    success-save-message="Возвраты созданы"
    :back-link="{ name: 'uc_b_refunds'}"
    :get-rows="getTempRefunds"
    :on-create="createTempRefund"
    :on-update="updateTempRefund"
    :on-delete="deleteTempRefund"
    :on-delete-all="deleteAllTempRefunds"
    :on-submit="saveRefunds"
    :row-template="template"
    :mobile-breakpoint="1100"
    :empty-row="emptyRow"
    :parse-row-body="parseRefund"
    :format-row="formatRefund"
    :show-total="true"
  />
</template>

<script>
import BulkAdd    from "@/components/calculated-program/invoices/BulkAdd";
import dateFormat from "date-fns/format";
import dateParse  from "date-fns/parse";

const today = new Date();
export default {
  name:       "RefundsAdd",
  components: { BulkAdd },
  data() {
    return {
      template:      [
        [
          {
            field:     'account_number',
            type:      'select',
            className: this.$style.account,
            label:     'Лицевой счёт',
            dataField: 'apartments',
          },
          // {
          //   field:     'payment_create_date',
          //   type:      'date',
          //   className: this.$style.createDate,
          //   label:     'Дата создания',
          // },
          {
            field:     'payment_passage_date',
            type:      'date',
            className: this.$style.passageDate,
            label:     'Дата проведения',
          },
          {
            field:     'all_amount',
            type:      'currency',
            className: this.$style.amount,
            label:     'Сумма',
          },
        ],
        [
          {
            field:     'check_number',
            type:      'text',
            className: this.$style.check,
            label:     'Номер чека',
          },
          {
            field:     'comment',
            type:      'text',
            className: this.$style.comment,
            label:     'Комментарий',
          },
        ],
      ],
      emptyRow:      {
        account_number:       null,
        payment_create_date:  today,
        payment_passage_date: today,
        all_amount:           null,
        check_number:         null,
        comment:              null,
      },
    };
  },
  computed:   {},
  methods:    {
    deleteAllTempRefunds( buildingId ) {
      return this.$http.delete('temp_invoices/all_refunds', { params: { buildings_id: buildingId } });
    },
    getTempRefunds( buildingId ) {
      return this.$http.get('temp_invoices/refunds', { params: { buildings_id: buildingId } });
    },
    createTempRefund( refund ) {
      return this.$http.post('temp_invoices/refunds', refund);
    },
    updateTempRefund( refund ) {
      return this.$http.put('temp_invoices/refunds', refund);
    },
    deleteTempRefund( buildingId, index ) {
      return this.$http.delete('temp_invoices/refunds', { params: { buildings_id: buildingId, index_id: index } });
    },
    saveRefunds( buildingId ) {
      return this.$http.post('temp_invoices/submit_refunds', { buildings_id: buildingId });
    },

    parseDate( dateStr, format ) {
      if (!dateStr) return null;
      const date = dateParse(dateStr, format, new Date());
      if (Number.isNaN(+date)) return null;
      return date;
    },

    formatDate( date, format ) {
      if (!date || Number.isNaN(+date)) return null;
      return dateFormat(date, format);
    },

    parseRefund( refund ) {
      refund.payment_create_date = this.parseDate(refund.payment_create_date, 'yyyy-MM-dd');
      refund.payment_passage_date = this.parseDate(refund.payment_passage_date, 'yyyy-MM-dd');
      return refund;
    },

    formatRefund( refund ) {
      refund = { ...refund };
      refund.payment_create_date = this.formatDate(refund.payment_create_date, 'yyyy-MM-dd');
      refund.payment_passage_date = this.formatDate(refund.payment_passage_date, 'yyyy-MM-dd');

      return refund;
    },
  },
};
</script>

<style lang="scss" module>
.account {
  width: 140px;
}

.amount {
  width: 100px;
}

.createDate {
  width: 130px;
}

.passageDate {
  width: 130px;
}

.check {
  width: 100px;
}

.comment {
  width: 170px;
}

</style>
